import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetDrinks } from "./useGetDrinks"
import { DrinkEntity } from "../../Objects/MealsAndDrinks/DrinkEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useSaveDrinks = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetDrinks } = useGetDrinks()

  const handleSavesDrink = async (drinkChange: DrinkEntity, onSuccess: any, imageFile?: any | null) => {
    try {
      enableLoad()

      var response = null

      if (drinkChange.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.DRINK.PUT}/${drinkChange.id}`, drinkChange.toJSON(imageFile))
      } else {
        response = await PostFormRequest(API_ROUTES.DRINK.CREATE, drinkChange.toJSON(imageFile))
      }

      if (response.success) {
        await handleGetDrinks(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSavesDrink,
  }
}
